const enableLogger = false;
function log(...args) {
  if (enableLogger) {
    console.log(args);
  }
}

const AustraliaStateMapping = {
  ACT: 'Australian Capital Territory',
  NSW: 'New South Wales',
  NT: 'Northern Territory',
  QLD: 'Queensland',
  SA: 'South Australia',
  TAS: 'Tasmania',
  VIC: 'Victoria',
  WA: 'Western Australia',
};

function insertAfter(referenceNode, newNode) {
  if (referenceNode && newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }
}

function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

function kleberConfig() {
  const config = window.kleber_app_config;
  if (config) {
    return JSON.parse(config)?.accountConfiguration ?? {};
  }
  return {};
}

async function verifyEmail(email) {
  if (!kleberConfig().enableEmailValidation) return true;

  const res = await fetch(`/apps/kleber/api/verifyEmail?email=${email}`).then((res) => res.json());
  if (
    res?.DtResponse?.Result?.length > 0 &&
    res?.DtResponse?.Result[0].StatusDescription.indexOf('Accept All') !== -1
  )
    return true;

  if (!(res?.DtResponse?.Result?.length > 0)) return true;
  if (res.DtResponse.Result[0].StatusCode == '0') return true;
  return false;
}

async function verifyPhoneNumber(phone) {
  if (!kleberConfig().enablePhoneValidation) return true;

  const res = await fetch(`/apps/kleber/api/verifyPhoneNumber?phone=${phone}`).then((res) =>
    res.json()
  );
  if (!(res?.DtResponse?.Result?.length > 0)) return true;
  if (res.DtResponse.Result[0].StatusCode == '0') return true;
  return false;
}

function showError(field, id, message) {
  field.classList.add('field--error');
  if (!document.getElementById(id)) {
    field.insertAdjacentHTML(
      'afterend',
      `<p class="field__message field__message--error" id="${id}">${message}</p>`
    );
  }
}

function cancelModal() {
  const modal = document.getElementById('kleber-app__address-correction-modal');
  modal.remove();
}

function keepAddress(formId) {
  cancelModal();

  document.getElementById(`address_form_${formId}`).submit();
}

function correctAddress(formId, data) {
  cancelModal();

  const suffix = formId === 'new' ? 'New' : `_${formId}`;

  const address = data.AddressLine;
  const city = data.Locality;
  const state = data.State;
  const zip = data.Postcode;
  const country = 'Australia';
  document.getElementById(`AddressAddress1${suffix}`).value = address;
  if (document.getElementById(`AddressAddress2${suffix}`))
    document.getElementById(`AddressAddress2${suffix}`).value = '';
  document.getElementById(`AddressCity${suffix}`).value = city;
  document.getElementById(`AddressCountry${suffix}`).value = country;
  document.getElementById(`AddressProvince${suffix}`).value = AustraliaStateMapping[state];
  document.getElementById(`AddressZip${suffix}`).value = zip;
  document.getElementById(`address_form_${formId}`).submit();
}

async function verifyAddress(formId) {
  if (!kleberConfig().enableAddressValidation) return true;

  const suffix = formId === 'new' ? 'New' : `_${formId}`;
  const address1 = document.getElementById(`AddressAddress1${suffix}`).value;
  const address2 = document.getElementById(`AddressAddress2${suffix}`)?.value ?? '';
  const city = document.getElementById(`AddressCity${suffix}`).value;
  const state = document.getElementById(`AddressProvince${suffix}`).value;
  const postcode = document.getElementById(`AddressZip${suffix}`).value;

  const res = await fetch(
    `/apps/kleber/api/repairAddress?address1=${address1}&address2=${address2}&city=${city}&state=${state}&postcode=${postcode}`
  ).then((res) => res.json());

  if (!(res?.DtResponse?.Result?.length > 0)) return true;

  const data = res.DtResponse.Result[0];

  if (data) {
    const matchType = data.MatchType;
    const fieldChanges = data.FieldChanges;

    if (matchType == '0' && fieldChanges?.length === 0) {
      return true;
    } else if (matchType == '0') {
      const address = data.AddressLine;
      const city = data.Locality;
      const state = data.State;
      const zip = data.Postcode;

      const modal = document.createElement('div');
      modal.id = 'kleber-app__address-correction-modal';
      modal.classList.add('kleber-app__address-correction__modal');
      modal.innerHTML = `<div class="kleber-app__address-correction__modal-content">
        <div class="kleber-app__address-correction__modal-title">Please confirm your shipping address</div>
        <div class="kleber-app__address-correction__address_block">${address}, ${city}, ${state} ${zip}</div>
        <div class="kleber-app__address-correction__buttons-group">
        <button class="kleber-app__address-correction__button" id="keep-address-button">Use original address</button>
        <button class="kleber-app__address-correction__button" id="correct-address-button">Use this address</button>
        </div>
      </div>`;
      document.body.appendChild(modal);
      document.getElementById('keep-address-button').addEventListener('click', function () {
        keepAddress(formId);
      });
      document.getElementById('correct-address-button').addEventListener('click', function () {
        correctAddress(formId, data);
      });

      if (kleberConfig().forceVerifiedAddress) {
        document.getElementById('keep-address-button').style.display = 'none';
      }
    } else {
      let message =
        'We couldn’t verify that address. You can click edit to check it, or proceed anyway.';
      let proceedButtonText = 'Proceed';
      if (matchType == '9' || matchType == '18') {
        message =
          address2?.length > 0
            ? 'Please make sure your unit/appartment number is correct.'
            : 'Please enter your unit/appartment number.';
        proceedButtonText = 'Ignore';
      }

      const modal = document.createElement('div');
      modal.id = 'kleber-app__address-correction-modal';
      modal.classList.add('kleber-app__address-correction__modal');
      modal.innerHTML = `<div class="kleber-app__address-correction__modal-content">
        <div class="kleber-app__address-correction__modal-title">${message}</div>
        <div class="kleber-app__address-correction__buttons-group">
        <button class="kleber-app__address-correction__button" id="keep-address-button">${proceedButtonText}</button>
        <button class="kleber-app__address-correction__button" onclick="cancelModal()">Edit address</button>
        </div>
      </div>`;
      document.body.appendChild(modal);
      document.getElementById('keep-address-button').addEventListener('click', function () {
        keepAddress(formId);
      });

      if (kleberConfig().forceVerifiedAddress) {
        document.getElementById('keep-address-button').style.display = 'none';
      }
    }
    return false;
  }
}

async function registerVerifyProcess() {
  let verified = true;
  let emailField = document.getElementsByName('customer[email]')[0];

  if (kleberConfig()?.emailFieldCSSSelector) {
    emailField = document.querySelector(kleberConfig()?.emailFieldCSSSelector);
  }

  if (emailField?.value?.length > 0) {
    const emailResult = await verifyEmail(emailField.value);
    if (!emailResult) {
      showError(emailField, 'error-for-email', 'Please enter a valid email');
      verified = false;
    }
  }

  let phoneField = document.getElementsByName('customer[phone]')[0];

  if (kleberConfig()?.phoneFieldCSSSelector) {
    phoneField = document.querySelector(kleberConfig()?.phoneFieldCSSSelector);
  }

  if (phoneField?.value?.length > 0) {
    const phoneResult = await verifyPhoneNumber(phoneField.value);
    if (!phoneResult) {
      showError(phoneField, 'error-for-phone', 'Please enter a valid phone number');
      verified = false;
    }
  }

  return verified;
}

async function addressVerifyProcess(formId) {
  log('phone changed:', window[`phone_${formId}_changed`]);
  log('address changed:', window[`address_${formId}_changed`]);
  let result = true;
  const suffix = formId === 'new' ? 'New' : `_${formId}`;

  const phoneField = document.getElementById(`AddressPhone${suffix}`);
  if (phoneField?.value?.length > 0 && window[`phone_${formId}_changed`]) {
    result = await verifyPhoneNumber(phoneField.value);
    if (!result) {
      showError(phoneField, `error-for-phone-${formId}`, 'Please enter a valid phone number');
      return result;
    }
    window[`phone_${formId}_changed`] = false;
  }

  if (window[`address_${formId}_changed`]) {
    result = await verifyAddress(formId);
  }

  return result;
}

async function retrieveAddress(addressId, containerId) {
  log('Retrieve Address:', addressId);
  const suffix = containerId.replace('AddressAddress1', '');
  const res = await fetch(`/apps/kleber/api/retrieveAddress?addressId=${addressId}`).then((res) =>
    res.json()
  );

  log('Retrieve Address Results:', res);

  const resultContainer = document.getElementById(`address-search-result-container-${containerId}`);

  resultContainer.innerHTML = '';
  resultContainer.classList.remove('kleber-app__autocomplete-suggestions--active');

  if (!(res?.DtResponse?.Result?.length > 0)) return;

  const data = res.DtResponse.Result[0];
  if (data) {
    const address = data.AddressLine;
    const city = data.Locality;
    const state = data.State;
    const zip = data.Postcode;
    const country = 'Australia';
    document.getElementById(`AddressAddress1${suffix}`).value = address;
    if (document.getElementById(`AddressAddress2${suffix}`))
      document.getElementById(`AddressAddress2${suffix}`).value = '';
    document.getElementById(`AddressCity${suffix}`).value = city;
    document.getElementById(`AddressCountry${suffix}`).value = country;
    document.getElementById(`AddressCountry${suffix}`).dispatchEvent(new Event('change'));
    document.getElementById(`AddressProvince${suffix}`).value = AustraliaStateMapping[state];
    document.getElementById(`AddressZip${suffix}`).value = zip;
  }
}

async function searchAddress(event) {
  const address = event.target.value;
  const containerId = event.target.id;
  log('Search Address:', address);

  const res = await fetch(`/apps/kleber/api/searchAddress?address=${address}&limit=5`).then((res) =>
    res.json()
  );

  log('Search Address Results:', res);

  const resultContainer = document.getElementById(`address-search-result-container-${containerId}`);
  resultContainer.style.top = `${event.target.offsetTop + 50}px`;

  resultContainer.innerHTML = '';
  resultContainer.classList.remove('kleber-app__autocomplete-suggestions--active');

  const data = res?.DtResponse?.Result;

  if (data?.length > 0) {
    data.forEach(function (record) {
      const item = document.createElement('button');
      item.setAttribute('id', record.RecordId);
      item.classList.add('kleber-app__autocomplete-suggestion');
      item.addEventListener('click', function (e) {
        e.preventDefault();
        retrieveAddress(e.target.id, containerId);
      });
      item.innerHTML = `${record.AddressLine}, ${record.Locality}, ${record.State}`;
      resultContainer.appendChild(item);
    });

    const item = document.createElement('button');
    item.classList.add(
      'kleber-app__autocomplete-suggestion',
      'kleber-app__autocomplete-suggestion-manual'
    );
    item.addEventListener('click', function (e) {
      e.preventDefault();
      resultContainer.innerHTML = '';
      resultContainer.classList.remove('kleber-app__autocomplete-suggestions--active');
      document.getElementById(containerId).removeEventListener('input', handleInputEvent);
    });
    item.innerHTML = 'Enter address manually';
    resultContainer.appendChild(item);

    resultContainer.classList.add('kleber-app__autocomplete-suggestions--active');

    const logoHtml = document.createElement('div');
    logoHtml.setAttribute('class', 'kleber-app__autocomplete-logo-container');

    const logo = document.createElement('img');
    logo.style.width = '100%';
    logo.src = 'https://assets.app.shopify.kleber.com.au/images/kleber_logo.jpg';
    logoHtml.appendChild(logo);
    resultContainer.appendChild(logoHtml);
  }
}

function debounce(func, timeout = 500) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

function clearError(elementId) {
  if (elementId) {
    const element = document.getElementById(elementId);
    element?.previousElementSibling?.classList.remove('field--error');
    element?.remove();
  }
}

const handleInputEvent = debounce(searchAddress);

docReady(function () {
  if (window.location.href.includes('account/register')) {
    if (!kleberConfig().enableEmailValidation) return;

    let emailField = document.getElementsByName('customer[email]')[0];

    if (kleberConfig()?.emailFieldCSSSelector) {
      emailField = document.querySelector(kleberConfig()?.emailFieldCSSSelector);
    }

    emailField?.addEventListener('input', () => {
      clearError('error-for-email');
    });

    let phoneField = document.getElementsByName('customer[phone]')[0];

    if (kleberConfig()?.phoneFieldCSSSelector) {
      phoneField = document.querySelector(kleberConfig()?.phoneFieldCSSSelector);
    }

    phoneField?.addEventListener('input', () => {
      clearError('error-for-phone');
    });

    let form = document.querySelector("form[action='/account']");

    if (kleberConfig().registrationFormCSSSelector) {
      form = document.querySelector(kleberConfig().registrationFormCSSSelector);
    }

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const passed = await registerVerifyProcess();
      if (passed) {
        form.submit();
      }
    });
  } else if (window.location.href.includes('account/addresses')) {
    const forms = document.getElementsByTagName('form');
    [...forms].forEach(function (form) {
      if (form.id.startsWith('address_form')) {
        const formId = form.id.replace('address_form_', '');
        const suffix = formId === 'new' ? 'New' : `_${formId}`;

        if (kleberConfig().enableAddressAutocomplete) {
          form.style.position = 'relative';

          const addressField = document.getElementById(`AddressAddress1${suffix}`);
          addressField?.setAttribute('autocomplete', 'disabled');
          document
            .getElementById(`AddressAddress2${suffix}`)
            ?.setAttribute('autocomplete', 'disabled');
          addressField?.addEventListener('input', handleInputEvent);

          const resultContainer = document.createElement('div');
          resultContainer.setAttribute('id', `address-search-result-container-${addressField.id}`);
          resultContainer.setAttribute('class', 'kleber-app__autocomplete-suggestions');

          insertAfter(addressField, resultContainer);
        }

        if (kleberConfig().enableAddressValidation) {
          document.getElementById(`AddressAddress1${suffix}`)?.addEventListener('input', () => {
            window[`address_${formId}_changed`] = true;
          });

          document.getElementById(`AddressAddress2${suffix}`)?.addEventListener('input', () => {
            window[`address_${formId}_changed`] = true;
          });
          document.getElementById(`AddressCity${suffix}`)?.addEventListener('input', () => {
            window[`address_${formId}_changed`] = true;
          });
          document.getElementById(`AddressCountry${suffix}`)?.addEventListener('input', () => {
            window[`address_${formId}_changed`] = true;
          });
          document.getElementById(`AddressProvince${suffix}`)?.addEventListener('input', () => {
            window[`address_${formId}_changed`] = true;
          });
          document.getElementById(`AddressZip${suffix}`)?.addEventListener('input', () => {
            window[`address_${formId}_changed`] = true;
          });
        }

        if (kleberConfig().enablePhoneValidation) {
          const phoneField = document.getElementById(`AddressPhone${suffix}`);
          phoneField?.addEventListener('input', () => {
            window[`phone_${formId}_changed`] = true;
            clearError(`error-for-phone-${formId}`);
          });
        }

        form.addEventListener('submit', async function (e) {
          e.preventDefault();
          const passed = await addressVerifyProcess(formId);
          if (passed) {
            form.submit();
          }
        });
      }
    });
  }
});
